import {
  DgaButton as Button,
  DgaTextarea as Textarea,
  DgaCheckbox,
  DgaRadioButton,
  DgaRating,
  DgaIcon,
  DgaLink,
  DgaNotification
} from "platformscode-new-react";
import RatingStar from "./RatingStar";
import React, { useState, useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { getRatingStats, getFeedbackStats, saveRating } from "../../services/api";

const Rating = ({ feedbackOptions }) => {
  const [isVisible, setIsVisible] = useState(true);
  const [isSubmit, setIsSubmit] = useState(false);
  const [currentRating, setCurrentRating] = useState(0);
  const [userSubmittedRating, setUserSubmittedRating] = useState(0);
  const [showAlert, setShowAlert] = useState(false);

  const location = useLocation();
  const textareaRef = useRef(null);
  const ratingRef = useRef(null);
  const ratingLabels = {
    1: "ضعيف",
    2: "مقبول",
    3: "جيد",
    4: "جيد جدًا",
    5: "ممتاز",

  };
  const [answer, setAnswer] = useState({
    isUseful: null,
    reasons: [],
    notes: "",
    gender: "",
  });

  const [errors, setErrors] = useState({
    reasons: false,
    gender: false,
  });

  const [openQuestions, setOpenQuestions] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [options, setOptions] = useState({
    yes: [],
    no: [],
  });

  const [stats, setStats] = useState({
    yesPercentage: 0,
    totalCount: 0,
  });

  // إحصائيات التقييم - تعديل القيم الافتراضية
  const [ratingStats, setRatingStats] = useState({
    averageRating: 0, // تغيير من 3.9 إلى 0
    totalRatings: 0,
  });

  // دالة للحصول على اسم الصفحة
  const getPageName = () => {
    return window.location.pathname.substring(1).split("?")[0] || "home";
  };

  useEffect(() => {
    if (feedbackOptions) {
      setOptions(feedbackOptions);
    }
  }, [feedbackOptions]);

  // جلب إحصائيات التقييم
  const fetchRatingStats = async () => {
    const pageUrl = getPageName();

    try {
      const data = await getRatingStats(pageUrl);

      if (data.data) {
        setRatingStats({
          averageRating: data.data.average_rating || 0,
          totalRatings: data.data.total_ratings || 0,
        });
      }
    } catch (error) {
      console.error("❌ خطأ في جلب إحصائيات التقييم:", error);
    }
  };

  const fetchFeedbackStats = async () => {
    const pageUrl = getPageName();

    try {
      const data = await getFeedbackStats(pageUrl);

      if (data.data) {
        setStats({
          yesPercentage: data.data.yes_percentage || 0,
          totalCount: data.data.total_count || 0,
        });
      }
    } catch (error) {
      console.error("❌ خطأ في جلب إحصائيات الفيدباك:", error);
    }
  };

  useEffect(() => {
    fetchFeedbackStats();
    fetchRatingStats();

    const statsInterval = setInterval(() => {
      fetchFeedbackStats();
      fetchRatingStats();
    }, 5 * 60 * 1000);

    return () => {
      clearInterval(statsInterval);
    };
  }, [location.pathname]);

  useEffect(() => {
    if (textareaRef.current && textareaRef.current.shadowRoot) {
      const textareaElement =
        textareaRef.current.shadowRoot.querySelector("textarea");
      if (textareaElement) {
        textareaElement.addEventListener("input", (e) => {
          setAnswer((prev) => ({ ...prev, notes: e.target.value }));
        });
      }
    }
  }, [textareaRef.current]);

  // معالج تغيير التقييم
  const handleRatingChange = (rating) => {
    console.log("⭐ تم اختيار تقييم:", rating);
    setCurrentRating(rating);
  };

  const handleSubmit = async () => {
    // طباعة القيمة الحالية للتشخيص

    if (currentRating === 0) {
      setShowAlert(true);   // show alert
      return;
    }

    setShowAlert(false);    // hide alert if rating is valid

    console.log("📝 جميع البيانات قبل الإرسال:", {
      rating: currentRating,
      notes: answer.notes,
      isUseful: answer.isUseful,
      reasons: answer.reasons,
    });

    try {
      let notesValue = answer.notes;
      if (textareaRef.current && textareaRef.current.shadowRoot) {
        const textareaElement =
          textareaRef.current.shadowRoot.querySelector("textarea");
        if (textareaElement) {
          notesValue = textareaElement.value;
        }
      }

      const pageUrl = getPageName();

      const payload = {
        rating: currentRating,
        isUseful: answer.isUseful,
        pageUrl: pageUrl,
        reasons: answer.reasons,
        notes: notesValue,
      };

      const data = await saveRating(payload);

      setSubmitted(true);
      setOpenQuestions(false);
      setIsVisible(false);
      setIsSubmit(true);
      setUserSubmittedRating(currentRating);
      fetchFeedbackStats();
      fetchRatingStats();
    } catch (error) {
      console.error("❌ خطأ في الإرسال:", error);
      alert("حدث خطأ في الاتصال");
    }
  };

  useEffect(() => {
    setSubmitted(false);
    setOpenQuestions(false);
    setIsVisible(true);
    setIsSubmit(false);
    setCurrentRating(0);
    setUserSubmittedRating(0);
    setAnswer({
      isUseful: null,
      reasons: [],
      notes: "",
      gender: "",
    });
    setErrors({
      reasons: false,
      gender: false,
    });
  }, [location.pathname]);

  return (
    <>
      <hr className="c-divider" />
      <div className="c-ontent">
        <section className="flex flex-col gap-8 !py-[24px] cw-full">
          <div className="w-full flex flex-col md:flex-row md:justify-between md:items-center max-md:gap-4">
            <div className="flex flex-col sm:flex-row sm:justify-between w-full gap-[24px]">
              {/* حذف علامة الصح من هنا - كانت تظهر في الأعلى */}

              {isVisible && !submitted && (
                <>
                  <div className="flex flex-col sm:flex-row items-start sm:items-center gap-4">
                    {/* عرض النص والنجوم فقط إذا كان هناك تقييمات */}
                    {ratingStats.totalRatings > 0 ? (
                      <>
                        <p className="text-md-regular text-[#161616] !text-[16px] leading-[24px]">
                          <span >
                            تم تقييم هذه الخدمة بمتوسط{" "}
                            <span className="!font-bold">
                              {ratingStats.averageRating}

                            </span>
                          </span>
                        </p>
                        <RatingStar
                          disabled={true}
                          value={Math.round(ratingStats.averageRating)}
                        />
                      </>
                    ) : (
                      <p className="text-md-regular text-[#161616] !text-[16px] leading-[24px]">
                        <span>كن أول من يقيم هذه الخدمة</span>
                      </p>
                    )}
                  </div>

                  <Button
                    label="قيم هذه الخدمة"
                    variant="primary-brand"
                    size="lg"
                    onClick={() => {
                      setAnswer({ ...answer, isUseful: "yes", reasons: [] });
                      setOpenQuestions(true);
                      setIsVisible(false);
                    }}
                    className="w-full sm:w-auto"
                  />
                </>
              )}

              {!isVisible && isSubmit && (
                <>
                  <div className="flex flex-col sm:flex-row items-start sm:items-center gap-[24px]">
                    <p className="text-md-regular text-[#161616] !text-[16px] leading-[24px]">
                      <span>
                        لقد قيّمت هذه الخدمة بـ
                        <b> ({userSubmittedRating}.0)</b>
                      </span>
                    </p>
                    <RatingStar disabled={true} value={userSubmittedRating} />
                  </div>

                  <div className="flex items-start sm:items-center gap-[24px]">
                    <DgaIcon
                      icon="checkmark-circle-04"
                      variant="stroke"
                      type="rounded"
                      color="#1B8354"
                      size="24px"
                    />
                    <div className="text-md-regular text-[#161616] !text-[16px] leading-[24px]">
                      تم إرسال تقييمك بنجاح!
                    </div>
                  </div>
                </>
              )}
            </div>

            {/* <div>
              {(!openQuestions || submitted) && stats.totalCount > 0 && (
                <p className="text-sm-regular text-[#161616]">
                  {stats.yesPercentage}% من المستخدمين قالوا نعم من{" "}
                  {stats.totalCount} تعليقًا
                </p>
              )}
            </div> */}
          </div>

          {openQuestions && answer.isUseful && !submitted && (
            <>

              <div className="flex flex-col gap-8">
                {/* Header section */}
                <div className="w-full flex justify-between max-md:flex-col max-md:gap-4">
                  <div className="order-1 max-md:order-2">
                    <h4 className="text-md-semibold !text-[16px] text-[#161616]">
                      أخبرنا عن رأيك في هذه الخدمة
                    </h4>
                    <p className="text-sm-regular text-[#6C737F] !text-[14px] !font-normal leading-[24px]">
                      يرجى عدم تضمين معلومات شخصية أو مالية. سيتم إرسال تعليقك
                      وتسجيله لغرض تحسين الخدمات.
                    </p>
                  </div>

                  <Button
                    className="order-2 max-md:order-1"
                    label="إغلاق"
                    variant="subtle"
                    trailIcon
                    trailIconType="cancel-circle"
                    trailIconProps={{ variant: "stroke", type: "standard" }}
                    size="lg"
                    onClick={() => {
                      setOpenQuestions(false);
                      setIsVisible(true);
                    }}
                  />
                </div>

                {showAlert && (

                  <DgaNotification
                    content="نرجو منك  استكمال الاستبيان لإرسال التقييم"
                    icon
                    leadText="مهم"
                    link
                    variant="critical"
                  />
                )}

                <div className="flex flex-col sm:flex-row sm:justify-between w-full gap-4">
                  {/* Rating section */}
                  <div className="flex flex-col gap-4">
                    <h4 className="text-md-semibold !text-[16px] text-[#161616]">
                      كيف تقيم هذه الخدمة؟
                    </h4>
                    <p className="text-sm-regular !text-[16px] !font-normal leading-[24px]">
                      قيم تجربتك من (1) ضعيف إلى (5) ممتاز
                    </p>
                    <RatingStar
                      value={currentRating}
                      onChange={handleRatingChange}
                    />

                    {showAlert && currentRating === 0 ? (
                      <div className="invalid-feedback flex justify-start gap-2">
                        <DgaIcon
                          color="#B42318"
                          icon="alert-circle"
                          size={16}
                          variant="stroke"
                        />
                        يرجى تقييم الخدمة
                      </div>
                    ) : (
                      currentRating > 0 && (
                        <p className="!text-[14px] text-gray-500">
                          تقييمك الحالي للخدمة: {ratingLabels[currentRating]}
                        </p>
                      )
                    )}


                  </div>

                  {/* Notes Textarea */}
                  <Textarea
                    ref={textareaRef}
                    label="اخبرنا عن تجربتك في هذه الخدمة"
                    name="notes"
                    value={answer.notes}
                    scrollbar
                    resize
                    onChange={(e) => {
                      // يتم التعامل مع التغيير في useEffect
                    }}
                    variant="default"
                    placeholder="اكتب ملاحظاتك هنا"
                  />
                </div>

                {/* Footer: Links and Submit */}
                <div className="w-full flex justify-between md:items-center max-md:flex-col gap-[24px]">

                  <div className="flex text-md-regular text-[#161616]gap-[2px] ">
                    <p className="text-md-regular text-[#161616] py-2">
                      لمزيد من المعلومات، يمكنك مراجعة&nbsp;
                    </p>
                    <div className="flex justify-center gap-[2px]">
                      <DgaLink
                        external={true}
                        label="بيان المشاركة الإلكترونية"
                        size="lg"
                        variant="brand"
                        onClick={() => {
                          window.open("https://my.gov.sa/ar/content/e-participation#section-1", "_blank", "noopener,noreferrer");
                        }}
                      />
                      <DgaIcon
                        color="#1b8354"
                        icon="link-square-02"
                        size={16}
                        type=""
                        variant="stroke"
                      />
                    </div>


                    &nbsp;و&nbsp;

                    <div className="flex justify-center gap-[2px]">
                      <DgaLink
                        external={true}
                        label="قواعد الاشتراك"
                        size="lg"
                        target="_blank"
                        onClick={() => {
                          window.open("https://my.gov.sa/ar/content/subscribe#section-1", "_blank", "noopener,noreferrer");
                        }}

                        variant="brand"
                      >
                      </DgaLink>
                      <DgaIcon
                        color="#1b8354"
                        icon="link-square-02"
                        size={16}
                        type=""
                        variant="stroke"
                      />
                    </div>



                  </div>

                  <Button
                    label="إرسال"
                    size="lg"
                    variant="primary-brand"
                    onClick={() => {
                      handleSubmit();
                    }}
                  />
                </div>
              </div>
            </>
          )}
        </section>
      </div>
    </>
  );
};

export default Rating;
